// Иконка флага — категория «Жалоба на контент» + кнопка жалобы на игру.
import React from "react";

export function FlagIcon({ size = 24, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
         stroke={color} strokeWidth="1.8"
         strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 22V4" />
      <path d="M5 4h12l-2 4 2 4H5" />
    </svg>
  );
}

export default FlagIcon;
